import React from "react";
import Login from "./LoginScreen/Login";
import Content3 from "./Content/Content3";

const Main = () => {
  return (
    <>
      {localStorage.getItem("userCredentials") === null ? (
        <Login />
      ) : (
        <Content3 />
      )}
    </>
  );
};

export default Main;
